import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { QueryFailedError } from "../../error/QueryFailedError";
import { QueryRunnerAlreadyReleasedError } from "../../error/QueryRunnerAlreadyReleasedError";
import { TransactionNotStartedError } from "../../error/TransactionNotStartedError";
import { BaseQueryRunner } from "../../query-runner/BaseQueryRunner";
import { Table } from "../../schema-builder/table/Table";
import { TableCheck } from "../../schema-builder/table/TableCheck";
import { TableColumn } from "../../schema-builder/table/TableColumn";
import { TableForeignKey } from "../../schema-builder/table/TableForeignKey";
import { TableIndex } from "../../schema-builder/table/TableIndex";
import { TableUnique } from "../../schema-builder/table/TableUnique";
import { View } from "../../schema-builder/view/View";
import { Broadcaster } from "../../subscriber/Broadcaster";
import { OrmUtils } from "../../util/OrmUtils";
import { Query } from "../Query";
import { TypeORMError } from "../../error";
import { QueryResult } from "../../query-runner/QueryResult";
import { MetadataTableType } from "../types/MetadataTableType";
/**
 * Runs queries on a single postgres database connection.
 */
export var SpannerQueryRunner = /*#__PURE__*/function (_BaseQueryRunner) {
  _inherits(SpannerQueryRunner, _BaseQueryRunner);
  var _super = _createSuper(SpannerQueryRunner);
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function SpannerQueryRunner(driver, mode) {
    var _this;
    _classCallCheck(this, SpannerQueryRunner);
    _this = _super.call(this);
    _this.driver = driver;
    _this.connection = driver.connection;
    _this.mode = mode;
    _this.broadcaster = new Broadcaster(_assertThisInitialized(_this));
    return _this;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Creates/uses database connection from the connection pool to perform further operations.
   * Returns obtained database connection.
   */
  _createClass(SpannerQueryRunner, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$this$driver$in, _yield$this$driver$in2, session;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.session) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", Promise.resolve(this.session));
            case 2:
              _context.next = 4;
              return this.driver.instanceDatabase.createSession({});
            case 4:
              _yield$this$driver$in = _context.sent;
              _yield$this$driver$in2 = _slicedToArray(_yield$this$driver$in, 1);
              session = _yield$this$driver$in2[0];
              this.session = session;
              _context.next = 10;
              return session.transaction();
            case 10:
              this.sessionTransaction = _context.sent;
              return _context.abrupt("return", this.session);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
    /**
     * Releases used database connection.
     * You cannot use query runner methods once its released.
     */
  }, {
    key: "release",
    value: function () {
      var _release = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.isReleased = true;
              if (!this.session) {
                _context2.next = 4;
                break;
              }
              _context2.next = 4;
              return this.session.delete();
            case 4:
              this.session = undefined;
              return _context2.abrupt("return", Promise.resolve());
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function release() {
        return _release.apply(this, arguments);
      }
      return release;
    }()
    /**
     * Starts transaction.
     */
  }, {
    key: "startTransaction",
    value: function () {
      var _startTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(isolationLevel) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.isTransactionActive = true;
              _context3.prev = 1;
              _context3.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionStart");
            case 4:
              _context3.next = 10;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              this.isTransactionActive = false;
              throw _context3.t0;
            case 10:
              _context3.next = 12;
              return this.connect();
            case 12:
              _context3.next = 14;
              return this.sessionTransaction.begin();
            case 14:
              this.connection.logger.logQuery("START TRANSACTION");
              _context3.next = 17;
              return this.broadcaster.broadcast("AfterTransactionStart");
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 6]]);
      }));
      function startTransaction(_x) {
        return _startTransaction.apply(this, arguments);
      }
      return startTransaction;
    }()
    /**
     * Commits transaction.
     * Error will be thrown if transaction was not started.
     */
  }, {
    key: "commitTransaction",
    value: function () {
      var _commitTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!this.isTransactionActive || !this.sessionTransaction)) {
                _context4.next = 2;
                break;
              }
              throw new TransactionNotStartedError();
            case 2:
              _context4.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionCommit");
            case 4:
              _context4.next = 6;
              return this.sessionTransaction.commit();
            case 6:
              this.connection.logger.logQuery("COMMIT");
              this.isTransactionActive = false;
              _context4.next = 10;
              return this.broadcaster.broadcast("AfterTransactionCommit");
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function commitTransaction() {
        return _commitTransaction.apply(this, arguments);
      }
      return commitTransaction;
    }()
    /**
     * Rollbacks transaction.
     * Error will be thrown if transaction was not started.
     */
  }, {
    key: "rollbackTransaction",
    value: function () {
      var _rollbackTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!this.isTransactionActive || !this.sessionTransaction)) {
                _context5.next = 2;
                break;
              }
              throw new TransactionNotStartedError();
            case 2:
              _context5.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionRollback");
            case 4:
              _context5.next = 6;
              return this.sessionTransaction.rollback();
            case 6:
              this.connection.logger.logQuery("ROLLBACK");
              this.isTransactionActive = false;
              _context5.next = 10;
              return this.broadcaster.broadcast("AfterTransactionRollback");
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function rollbackTransaction() {
        return _rollbackTransaction.apply(this, arguments);
      }
      return rollbackTransaction;
    }()
    /**
     * Executes a given SQL query.
     */
  }, {
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(_query, parameters) {
        var useStructuredResult,
          queryStartTime,
          rawResult,
          isSelect,
          executor,
          maxQueryExecutionTime,
          queryEndTime,
          queryExecutionTime,
          result,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              useStructuredResult = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : false;
              if (!this.isReleased) {
                _context6.next = 3;
                break;
              }
              throw new QueryRunnerAlreadyReleasedError();
            case 3:
              _context6.prev = 3;
              queryStartTime = +new Date();
              _context6.next = 7;
              return this.connect();
            case 7:
              rawResult = undefined;
              isSelect = _query.startsWith("SELECT");
              executor = isSelect && !this.isTransactionActive ? this.driver.instanceDatabase : this.sessionTransaction;
              if (!(!this.isTransactionActive && !isSelect)) {
                _context6.next = 13;
                break;
              }
              _context6.next = 13;
              return this.sessionTransaction.begin();
            case 13:
              _context6.prev = 13;
              this.driver.connection.logger.logQuery(_query, parameters, this);
              _context6.next = 17;
              return executor.run({
                sql: _query,
                params: parameters ? parameters.reduce(function (params, value, index) {
                  params["param" + index] = value;
                  return params;
                }, {}) : undefined,
                json: true
              });
            case 17:
              rawResult = _context6.sent;
              if (!(!this.isTransactionActive && !isSelect)) {
                _context6.next = 21;
                break;
              }
              _context6.next = 21;
              return this.sessionTransaction.commit();
            case 21:
              _context6.next = 34;
              break;
            case 23:
              _context6.prev = 23;
              _context6.t0 = _context6["catch"](13);
              _context6.prev = 25;
              if (!(!this.isTransactionActive && !isSelect)) {
                _context6.next = 29;
                break;
              }
              _context6.next = 29;
              return this.sessionTransaction.rollback();
            case 29:
              _context6.next = 33;
              break;
            case 31:
              _context6.prev = 31;
              _context6.t1 = _context6["catch"](25);
            case 33:
              throw _context6.t0;
            case 34:
              // log slow queries if maxQueryExecution time is set
              maxQueryExecutionTime = this.driver.options.maxQueryExecutionTime;
              queryEndTime = +new Date();
              queryExecutionTime = queryEndTime - queryStartTime;
              if (maxQueryExecutionTime && queryExecutionTime > maxQueryExecutionTime) this.driver.connection.logger.logQuerySlow(queryExecutionTime, _query, parameters, this);
              result = new QueryResult();
              result.raw = rawResult;
              result.records = rawResult ? rawResult[0] : [];
              if (rawResult && rawResult[1] && rawResult[1].rowCountExact) {
                result.affected = parseInt(rawResult[1].rowCountExact);
              }
              if (useStructuredResult) {
                _context6.next = 44;
                break;
              }
              return _context6.abrupt("return", result.records);
            case 44:
              return _context6.abrupt("return", result);
            case 47:
              _context6.prev = 47;
              _context6.t2 = _context6["catch"](3);
              this.driver.connection.logger.logQueryError(_context6.t2, _query, parameters, this);
              throw new QueryFailedError(_query, parameters, _context6.t2);
            case 51:
              _context6.prev = 51;
              return _context6.finish(51);
            case 53:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[3, 47, 51, 53], [13, 23], [25, 31]]);
      }));
      function query(_x2, _x3) {
        return _query2.apply(this, arguments);
      }
      return query;
    }()
    /**
     * Update database schema.
     * Used for creating/altering/dropping tables, columns, indexes, etc.
     *
     * DDL changing queries should be executed by `updateSchema()` method.
     */
  }, {
    key: "updateDDL",
    value: function () {
      var _updateDDL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(query, parameters) {
        var queryStartTime, _yield$this$driver$in3, _yield$this$driver$in4, operation, maxQueryExecutionTime, queryEndTime, queryExecutionTime;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!this.isReleased) {
                _context7.next = 2;
                break;
              }
              throw new QueryRunnerAlreadyReleasedError();
            case 2:
              this.driver.connection.logger.logQuery(query, parameters, this);
              _context7.prev = 3;
              queryStartTime = +new Date();
              _context7.next = 7;
              return this.driver.instanceDatabase.updateSchema(query);
            case 7:
              _yield$this$driver$in3 = _context7.sent;
              _yield$this$driver$in4 = _slicedToArray(_yield$this$driver$in3, 1);
              operation = _yield$this$driver$in4[0];
              _context7.next = 12;
              return operation.promise();
            case 12:
              // log slow queries if maxQueryExecution time is set
              maxQueryExecutionTime = this.driver.options.maxQueryExecutionTime;
              queryEndTime = +new Date();
              queryExecutionTime = queryEndTime - queryStartTime;
              if (maxQueryExecutionTime && queryExecutionTime > maxQueryExecutionTime) this.driver.connection.logger.logQuerySlow(queryExecutionTime, query, parameters, this);
              _context7.next = 22;
              break;
            case 18:
              _context7.prev = 18;
              _context7.t0 = _context7["catch"](3);
              this.driver.connection.logger.logQueryError(_context7.t0, query, parameters, this);
              throw new QueryFailedError(query, parameters, _context7.t0);
            case 22:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[3, 18]]);
      }));
      function updateDDL(_x4, _x5) {
        return _updateDDL.apply(this, arguments);
      }
      return updateDDL;
    }()
    /**
     * Returns raw data stream.
     */
  }, {
    key: "stream",
    value: function () {
      var _stream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(query, parameters, onEnd, onError) {
        var request, _stream2;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!this.isReleased) {
                _context8.next = 2;
                break;
              }
              throw new QueryRunnerAlreadyReleasedError();
            case 2:
              _context8.prev = 2;
              this.driver.connection.logger.logQuery(query, parameters, this);
              request = {
                sql: query,
                params: parameters ? parameters.reduce(function (params, value, index) {
                  params["param" + index] = value;
                  return params;
                }, {}) : undefined,
                json: true
              };
              _stream2 = this.driver.instanceDatabase.runStream(request);
              if (onEnd) {
                _stream2.on("end", onEnd);
              }
              if (onError) {
                _stream2.on("error", onError);
              }
              return _context8.abrupt("return", _stream2);
            case 11:
              _context8.prev = 11;
              _context8.t0 = _context8["catch"](2);
              this.driver.connection.logger.logQueryError(_context8.t0, query, parameters, this);
              throw new QueryFailedError(query, parameters, _context8.t0);
            case 15:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[2, 11]]);
      }));
      function stream(_x6, _x7, _x8, _x9) {
        return _stream.apply(this, arguments);
      }
      return stream;
    }()
    /**
     * Returns all available database names including system databases.
     */
  }, {
    key: "getDatabases",
    value: function () {
      var _getDatabases = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", Promise.resolve([]));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function getDatabases() {
        return _getDatabases.apply(this, arguments);
      }
      return getDatabases;
    }()
    /**
     * Returns all available schema names including system schemas.
     * If database parameter specified, returns schemas of that database.
     */
  }, {
    key: "getSchemas",
    value: function () {
      var _getSchemas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(database) {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", Promise.resolve([]));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function getSchemas(_x10) {
        return _getSchemas.apply(this, arguments);
      }
      return getSchemas;
    }()
    /**
     * Checks if database with the given name exist.
     */
  }, {
    key: "hasDatabase",
    value: function () {
      var _hasDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(database) {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              throw new TypeORMError("Check database queries are not supported by Spanner driver.");
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      function hasDatabase(_x11) {
        return _hasDatabase.apply(this, arguments);
      }
      return hasDatabase;
    }()
    /**
     * Loads currently using database
     */
  }, {
    key: "getCurrentDatabase",
    value: function () {
      var _getCurrentDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              throw new TypeORMError("Check database queries are not supported by Spanner driver.");
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      function getCurrentDatabase() {
        return _getCurrentDatabase.apply(this, arguments);
      }
      return getCurrentDatabase;
    }()
    /**
     * Checks if schema with the given name exist.
     */
  }, {
    key: "hasSchema",
    value: function () {
      var _hasSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(schema) {
        var result;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.query("SELECT * FROM \"information_schema\".\"schemata\" WHERE \"schema_name\" = '".concat(schema, "'"));
            case 2:
              result = _context13.sent;
              return _context13.abrupt("return", result.length ? true : false);
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function hasSchema(_x12) {
        return _hasSchema.apply(this, arguments);
      }
      return hasSchema;
    }()
    /**
     * Loads currently using database schema
     */
  }, {
    key: "getCurrentSchema",
    value: function () {
      var _getCurrentSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              throw new TypeORMError("Check schema queries are not supported by Spanner driver.");
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      function getCurrentSchema() {
        return _getCurrentSchema.apply(this, arguments);
      }
      return getCurrentSchema;
    }()
    /**
     * Checks if table with the given name exist in the database.
     */
  }, {
    key: "hasTable",
    value: function () {
      var _hasTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(tableOrName) {
        var tableName, sql, result;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              tableName = tableOrName instanceof Table ? tableOrName.name : tableOrName;
              sql = "SELECT * FROM `INFORMATION_SCHEMA`.`TABLES` " + "WHERE `TABLE_CATALOG` = '' AND `TABLE_SCHEMA` = '' AND `TABLE_TYPE` = 'BASE TABLE' " + "AND `TABLE_NAME` = '".concat(tableName, "'");
              _context15.next = 4;
              return this.query(sql);
            case 4:
              result = _context15.sent;
              return _context15.abrupt("return", result.length ? true : false);
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function hasTable(_x13) {
        return _hasTable.apply(this, arguments);
      }
      return hasTable;
    }()
    /**
     * Checks if column with the given name exist in the given table.
     */
  }, {
    key: "hasColumn",
    value: function () {
      var _hasColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(tableOrName, columnName) {
        var tableName, sql, result;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              tableName = tableOrName instanceof Table ? tableOrName.name : tableOrName;
              sql = "SELECT * FROM `INFORMATION_SCHEMA`.`COLUMNS` " + "WHERE `TABLE_CATALOG` = '' AND `TABLE_SCHEMA` = '' " + "AND `TABLE_NAME` = '".concat(tableName, "' AND `COLUMN_NAME` = '").concat(columnName, "'");
              _context16.next = 4;
              return this.query(sql);
            case 4:
              result = _context16.sent;
              return _context16.abrupt("return", result.length ? true : false);
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function hasColumn(_x14, _x15) {
        return _hasColumn.apply(this, arguments);
      }
      return hasColumn;
    }()
    /**
     * Creates a new database.
     * Note: Spanner does not support database creation inside a transaction block.
     */
  }, {
    key: "createDatabase",
    value: function () {
      var _createDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(database, ifNotExist) {
        var databaseAlreadyExists, up, down;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (!ifNotExist) {
                _context17.next = 6;
                break;
              }
              _context17.next = 3;
              return this.hasDatabase(database);
            case 3:
              databaseAlreadyExists = _context17.sent;
              if (!databaseAlreadyExists) {
                _context17.next = 6;
                break;
              }
              return _context17.abrupt("return", Promise.resolve());
            case 6:
              up = "CREATE DATABASE \"".concat(database, "\"");
              down = "DROP DATABASE \"".concat(database, "\"");
              _context17.next = 10;
              return this.executeQueries(new Query(up), new Query(down));
            case 10:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function createDatabase(_x16, _x17) {
        return _createDatabase.apply(this, arguments);
      }
      return createDatabase;
    }()
    /**
     * Drops database.
     * Note: Spanner does not support database dropping inside a transaction block.
     */
  }, {
    key: "dropDatabase",
    value: function () {
      var _dropDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(database, ifExist) {
        var up, down;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              up = ifExist ? "DROP DATABASE IF EXISTS \"".concat(database, "\"") : "DROP DATABASE \"".concat(database, "\"");
              down = "CREATE DATABASE \"".concat(database, "\"");
              _context18.next = 4;
              return this.executeQueries(new Query(up), new Query(down));
            case 4:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function dropDatabase(_x18, _x19) {
        return _dropDatabase.apply(this, arguments);
      }
      return dropDatabase;
    }()
    /**
     * Creates a new table schema.
     */
  }, {
    key: "createSchema",
    value: function () {
      var _createSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(schemaPath, ifNotExist) {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", Promise.resolve());
            case 1:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      function createSchema(_x20, _x21) {
        return _createSchema.apply(this, arguments);
      }
      return createSchema;
    }()
    /**
     * Drops table schema.
     */
  }, {
    key: "dropSchema",
    value: function () {
      var _dropSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(schemaPath, ifExist, isCascade) {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", Promise.resolve());
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      function dropSchema(_x22, _x23, _x24) {
        return _dropSchema.apply(this, arguments);
      }
      return dropSchema;
    }()
    /**
     * Creates a new table.
     */
  }, {
    key: "createTable",
    value: function () {
      var _createTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(table) {
        var _this2 = this;
        var ifNotExist,
          createForeignKeys,
          createIndices,
          isTableExist,
          upQueries,
          downQueries,
          generatedColumns,
          _iterator,
          _step,
          column,
          insertQuery,
          deleteQuery,
          _args21 = arguments;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              ifNotExist = _args21.length > 1 && _args21[1] !== undefined ? _args21[1] : false;
              createForeignKeys = _args21.length > 2 && _args21[2] !== undefined ? _args21[2] : true;
              createIndices = _args21.length > 3 && _args21[3] !== undefined ? _args21[3] : true;
              if (!ifNotExist) {
                _context21.next = 9;
                break;
              }
              _context21.next = 6;
              return this.hasTable(table);
            case 6:
              isTableExist = _context21.sent;
              if (!isTableExist) {
                _context21.next = 9;
                break;
              }
              return _context21.abrupt("return", Promise.resolve());
            case 9:
              upQueries = [];
              downQueries = [];
              upQueries.push(this.createTableSql(table, createForeignKeys));
              downQueries.push(this.dropTableSql(table));
              // if createForeignKeys is true, we must drop created foreign keys in down query.
              // createTable does not need separate method to create foreign keys, because it create fk's in the same query with table creation.
              if (createForeignKeys) table.foreignKeys.forEach(function (foreignKey) {
                return downQueries.push(_this2.dropForeignKeySql(table, foreignKey));
              });
              if (createIndices) {
                table.indices.forEach(function (index) {
                  // new index may be passed without name. In this case we generate index name manually.
                  if (!index.name) index.name = _this2.connection.namingStrategy.indexName(table, index.columnNames, index.where);
                  upQueries.push(_this2.createIndexSql(table, index));
                  downQueries.push(_this2.dropIndexSql(table, index));
                });
              }
              // if table has column with generated type, we must add the expression to the metadata table
              generatedColumns = table.columns.filter(function (column) {
                return column.generatedType && column.asExpression;
              });
              _iterator = _createForOfIteratorHelper(generatedColumns);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  column = _step.value;
                  insertQuery = this.insertTypeormMetadataSql({
                    table: table.name,
                    type: MetadataTableType.GENERATED_COLUMN,
                    name: column.name,
                    value: column.asExpression
                  });
                  deleteQuery = this.deleteTypeormMetadataSql({
                    table: table.name,
                    type: MetadataTableType.GENERATED_COLUMN,
                    name: column.name
                  });
                  upQueries.push(insertQuery);
                  downQueries.push(deleteQuery);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context21.next = 20;
              return this.executeQueries(upQueries, downQueries);
            case 20:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function createTable(_x25) {
        return _createTable.apply(this, arguments);
      }
      return createTable;
    }()
    /**
     * Drops the table.
     */
  }, {
    key: "dropTable",
    value: function () {
      var _dropTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(target, ifExist) {
        var _this3 = this;
        var dropForeignKeys,
          dropIndices,
          isTableExist,
          createForeignKeys,
          tablePath,
          table,
          upQueries,
          downQueries,
          generatedColumns,
          _iterator2,
          _step2,
          column,
          deleteQuery,
          insertQuery,
          _args22 = arguments;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              dropForeignKeys = _args22.length > 2 && _args22[2] !== undefined ? _args22[2] : true;
              dropIndices = _args22.length > 3 && _args22[3] !== undefined ? _args22[3] : true;
              if (!ifExist) {
                _context22.next = 8;
                break;
              }
              _context22.next = 5;
              return this.hasTable(target);
            case 5:
              isTableExist = _context22.sent;
              if (isTableExist) {
                _context22.next = 8;
                break;
              }
              return _context22.abrupt("return", Promise.resolve());
            case 8:
              // if dropTable called with dropForeignKeys = true, we must create foreign keys in down query.
              createForeignKeys = dropForeignKeys;
              tablePath = this.getTablePath(target);
              _context22.next = 12;
              return this.getCachedTable(tablePath);
            case 12:
              table = _context22.sent;
              upQueries = [];
              downQueries = [];
              if (dropIndices) {
                table.indices.forEach(function (index) {
                  upQueries.push(_this3.dropIndexSql(table, index));
                  downQueries.push(_this3.createIndexSql(table, index));
                });
              }
              if (dropForeignKeys) table.foreignKeys.forEach(function (foreignKey) {
                return upQueries.push(_this3.dropForeignKeySql(table, foreignKey));
              });
              upQueries.push(this.dropTableSql(table));
              downQueries.push(this.createTableSql(table, createForeignKeys));
              // if table had columns with generated type, we must remove the expression from the metadata table
              generatedColumns = table.columns.filter(function (column) {
                return column.generatedType && column.asExpression;
              });
              _iterator2 = _createForOfIteratorHelper(generatedColumns);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  column = _step2.value;
                  deleteQuery = this.deleteTypeormMetadataSql({
                    table: table.name,
                    type: MetadataTableType.GENERATED_COLUMN,
                    name: column.name
                  });
                  insertQuery = this.insertTypeormMetadataSql({
                    table: table.name,
                    type: MetadataTableType.GENERATED_COLUMN,
                    name: column.name,
                    value: column.asExpression
                  });
                  upQueries.push(deleteQuery);
                  downQueries.push(insertQuery);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context22.next = 24;
              return this.executeQueries(upQueries, downQueries);
            case 24:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function dropTable(_x26, _x27) {
        return _dropTable.apply(this, arguments);
      }
      return dropTable;
    }()
    /**
     * Creates a new view.
     */
  }, {
    key: "createView",
    value: function () {
      var _createView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(view) {
        var upQueries, downQueries;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              upQueries = [];
              downQueries = [];
              upQueries.push(this.createViewSql(view));
              _context23.t0 = upQueries;
              _context23.next = 6;
              return this.insertViewDefinitionSql(view);
            case 6:
              _context23.t1 = _context23.sent;
              _context23.t0.push.call(_context23.t0, _context23.t1);
              downQueries.push(this.dropViewSql(view));
              _context23.t2 = downQueries;
              _context23.next = 12;
              return this.deleteViewDefinitionSql(view);
            case 12:
              _context23.t3 = _context23.sent;
              _context23.t2.push.call(_context23.t2, _context23.t3);
              _context23.next = 16;
              return this.executeQueries(upQueries, downQueries);
            case 16:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function createView(_x28) {
        return _createView.apply(this, arguments);
      }
      return createView;
    }()
    /**
     * Drops the view.
     */
  }, {
    key: "dropView",
    value: function () {
      var _dropView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(target) {
        var viewName, view, upQueries, downQueries;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              viewName = target instanceof View ? target.name : target;
              _context24.next = 3;
              return this.getCachedView(viewName);
            case 3:
              view = _context24.sent;
              upQueries = [];
              downQueries = [];
              _context24.t0 = upQueries;
              _context24.next = 9;
              return this.deleteViewDefinitionSql(view);
            case 9:
              _context24.t1 = _context24.sent;
              _context24.t0.push.call(_context24.t0, _context24.t1);
              upQueries.push(this.dropViewSql(view));
              _context24.t2 = downQueries;
              _context24.next = 15;
              return this.insertViewDefinitionSql(view);
            case 15:
              _context24.t3 = _context24.sent;
              _context24.t2.push.call(_context24.t2, _context24.t3);
              downQueries.push(this.createViewSql(view));
              _context24.next = 20;
              return this.executeQueries(upQueries, downQueries);
            case 20:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function dropView(_x29) {
        return _dropView.apply(this, arguments);
      }
      return dropView;
    }()
    /**
     * Renames the given table.
     */
  }, {
    key: "renameTable",
    value: function () {
      var _renameTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(oldTableOrName, newTableName) {
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              throw new TypeORMError("Rename table queries are not supported by Spanner driver.");
            case 1:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }));
      function renameTable(_x30, _x31) {
        return _renameTable.apply(this, arguments);
      }
      return renameTable;
    }()
    /**
     * Creates a new column from the column in the table.
     */
  }, {
    key: "addColumn",
    value: function () {
      var _addColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(tableOrName, column) {
        var table, clonedTable, upQueries, downQueries, columnIndex, uniqueIndex, insertQuery, deleteQuery;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!(tableOrName instanceof Table)) {
                _context26.next = 4;
                break;
              }
              _context26.t0 = tableOrName;
              _context26.next = 7;
              break;
            case 4:
              _context26.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context26.t0 = _context26.sent;
            case 7:
              table = _context26.t0;
              clonedTable = table.clone();
              upQueries = [];
              downQueries = [];
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD ").concat(this.buildCreateColumnSql(column))));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP COLUMN ").concat(this.driver.escape(column.name))));
              // create column index
              columnIndex = clonedTable.indices.find(function (index) {
                return index.columnNames.length === 1 && index.columnNames[0] === column.name;
              });
              if (columnIndex) {
                upQueries.push(this.createIndexSql(table, columnIndex));
                downQueries.push(this.dropIndexSql(table, columnIndex));
              } else if (column.isUnique) {
                uniqueIndex = new TableIndex({
                  name: this.connection.namingStrategy.indexName(table, [column.name]),
                  columnNames: [column.name],
                  isUnique: true
                });
                clonedTable.indices.push(uniqueIndex);
                clonedTable.uniques.push(new TableUnique({
                  name: uniqueIndex.name,
                  columnNames: uniqueIndex.columnNames
                }));
                upQueries.push(this.createIndexSql(table, uniqueIndex));
                downQueries.push(this.dropIndexSql(table, uniqueIndex));
              }
              if (column.generatedType && column.asExpression) {
                insertQuery = this.insertTypeormMetadataSql({
                  table: table.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: column.name,
                  value: column.asExpression
                });
                deleteQuery = this.deleteTypeormMetadataSql({
                  table: table.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: column.name
                });
                upQueries.push(insertQuery);
                downQueries.push(deleteQuery);
              }
              _context26.next = 18;
              return this.executeQueries(upQueries, downQueries);
            case 18:
              clonedTable.addColumn(column);
              this.replaceCachedTable(table, clonedTable);
            case 20:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function addColumn(_x32, _x33) {
        return _addColumn.apply(this, arguments);
      }
      return addColumn;
    }()
    /**
     * Creates a new columns from the column in the table.
     */
  }, {
    key: "addColumns",
    value: function () {
      var _addColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(tableOrName, columns) {
        var _iterator3, _step3, column;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(columns);
              _context27.prev = 1;
              _iterator3.s();
            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context27.next = 9;
                break;
              }
              column = _step3.value;
              _context27.next = 7;
              return this.addColumn(tableOrName, column);
            case 7:
              _context27.next = 3;
              break;
            case 9:
              _context27.next = 14;
              break;
            case 11:
              _context27.prev = 11;
              _context27.t0 = _context27["catch"](1);
              _iterator3.e(_context27.t0);
            case 14:
              _context27.prev = 14;
              _iterator3.f();
              return _context27.finish(14);
            case 17:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this, [[1, 11, 14, 17]]);
      }));
      function addColumns(_x34, _x35) {
        return _addColumns.apply(this, arguments);
      }
      return addColumns;
    }()
    /**
     * Renames column in the given table.
     */
  }, {
    key: "renameColumn",
    value: function () {
      var _renameColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(tableOrName, oldTableColumnOrName, newTableColumnOrName) {
        var table, oldColumn, newColumn;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              if (!(tableOrName instanceof Table)) {
                _context28.next = 4;
                break;
              }
              _context28.t0 = tableOrName;
              _context28.next = 7;
              break;
            case 4:
              _context28.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context28.t0 = _context28.sent;
            case 7:
              table = _context28.t0;
              oldColumn = oldTableColumnOrName instanceof TableColumn ? oldTableColumnOrName : table.columns.find(function (c) {
                return c.name === oldTableColumnOrName;
              });
              if (oldColumn) {
                _context28.next = 11;
                break;
              }
              throw new TypeORMError("Column \"".concat(oldTableColumnOrName, "\" was not found in the \"").concat(table.name, "\" table."));
            case 11:
              if (newTableColumnOrName instanceof TableColumn) {
                newColumn = newTableColumnOrName;
              } else {
                newColumn = oldColumn.clone();
                newColumn.name = newTableColumnOrName;
              }
              return _context28.abrupt("return", this.changeColumn(table, oldColumn, newColumn));
            case 13:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function renameColumn(_x36, _x37, _x38) {
        return _renameColumn.apply(this, arguments);
      }
      return renameColumn;
    }()
    /**
     * Changes a column in the table.
     */
  }, {
    key: "changeColumn",
    value: function () {
      var _changeColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(tableOrName, oldTableColumnOrName, newColumn) {
        var table, clonedTable, upQueries, downQueries, oldColumn, uniqueIndex, _uniqueIndex, tableUnique;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              if (!(tableOrName instanceof Table)) {
                _context29.next = 4;
                break;
              }
              _context29.t0 = tableOrName;
              _context29.next = 7;
              break;
            case 4:
              _context29.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context29.t0 = _context29.sent;
            case 7:
              table = _context29.t0;
              clonedTable = table.clone();
              upQueries = [];
              downQueries = [];
              oldColumn = oldTableColumnOrName instanceof TableColumn ? oldTableColumnOrName : table.columns.find(function (column) {
                return column.name === oldTableColumnOrName;
              });
              if (oldColumn) {
                _context29.next = 14;
                break;
              }
              throw new TypeORMError("Column \"".concat(oldTableColumnOrName, "\" was not found in the \"").concat(table.name, "\" table."));
            case 14:
              if (!(oldColumn.name !== newColumn.name || oldColumn.type !== newColumn.type || oldColumn.length !== newColumn.length || oldColumn.isArray !== newColumn.isArray || oldColumn.generatedType !== newColumn.generatedType || oldColumn.asExpression !== newColumn.asExpression)) {
                _context29.next = 22;
                break;
              }
              _context29.next = 17;
              return this.dropColumn(table, oldColumn);
            case 17:
              _context29.next = 19;
              return this.addColumn(table, newColumn);
            case 19:
              // update cloned table
              clonedTable = table.clone();
              _context29.next = 25;
              break;
            case 22:
              if (newColumn.precision !== oldColumn.precision || newColumn.scale !== oldColumn.scale) {
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" TYPE ").concat(this.driver.createFullType(newColumn))));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" TYPE ").concat(this.driver.createFullType(oldColumn))));
              }
              if (oldColumn.isNullable !== newColumn.isNullable) {
                if (newColumn.isNullable) {
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" DROP NOT NULL")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" SET NOT NULL")));
                } else {
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" SET NOT NULL")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" DROP NOT NULL")));
                }
              }
              if (newColumn.isUnique !== oldColumn.isUnique) {
                if (newColumn.isUnique === true) {
                  uniqueIndex = new TableIndex({
                    name: this.connection.namingStrategy.indexName(table, [newColumn.name]),
                    columnNames: [newColumn.name],
                    isUnique: true
                  });
                  clonedTable.indices.push(uniqueIndex);
                  clonedTable.uniques.push(new TableUnique({
                    name: uniqueIndex.name,
                    columnNames: uniqueIndex.columnNames
                  }));
                  upQueries.push(this.createIndexSql(table, uniqueIndex));
                  downQueries.push(this.dropIndexSql(table, uniqueIndex));
                } else {
                  _uniqueIndex = clonedTable.indices.find(function (index) {
                    return index.columnNames.length === 1 && index.isUnique === true && !!index.columnNames.find(function (columnName) {
                      return columnName === newColumn.name;
                    });
                  });
                  clonedTable.indices.splice(clonedTable.indices.indexOf(_uniqueIndex), 1);
                  tableUnique = clonedTable.uniques.find(function (unique) {
                    return unique.name === _uniqueIndex.name;
                  });
                  clonedTable.uniques.splice(clonedTable.uniques.indexOf(tableUnique), 1);
                  upQueries.push(this.dropIndexSql(table, _uniqueIndex));
                  downQueries.push(this.createIndexSql(table, _uniqueIndex));
                }
              }
            case 25:
              _context29.next = 27;
              return this.executeQueries(upQueries, downQueries);
            case 27:
              this.replaceCachedTable(table, clonedTable);
            case 28:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function changeColumn(_x39, _x40, _x41) {
        return _changeColumn.apply(this, arguments);
      }
      return changeColumn;
    }()
    /**
     * Changes a column in the table.
     */
  }, {
    key: "changeColumns",
    value: function () {
      var _changeColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(tableOrName, changedColumns) {
        var _iterator4, _step4, _step4$value, oldColumn, newColumn;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _iterator4 = _createForOfIteratorHelper(changedColumns);
              _context30.prev = 1;
              _iterator4.s();
            case 3:
              if ((_step4 = _iterator4.n()).done) {
                _context30.next = 9;
                break;
              }
              _step4$value = _step4.value, oldColumn = _step4$value.oldColumn, newColumn = _step4$value.newColumn;
              _context30.next = 7;
              return this.changeColumn(tableOrName, oldColumn, newColumn);
            case 7:
              _context30.next = 3;
              break;
            case 9:
              _context30.next = 14;
              break;
            case 11:
              _context30.prev = 11;
              _context30.t0 = _context30["catch"](1);
              _iterator4.e(_context30.t0);
            case 14:
              _context30.prev = 14;
              _iterator4.f();
              return _context30.finish(14);
            case 17:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this, [[1, 11, 14, 17]]);
      }));
      function changeColumns(_x42, _x43) {
        return _changeColumns.apply(this, arguments);
      }
      return changeColumns;
    }()
    /**
     * Drops column in the table.
     */
  }, {
    key: "dropColumn",
    value: function () {
      var _dropColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(tableOrName, columnOrName) {
        var table, column, clonedTable, upQueries, downQueries, columnIndex, columnCheck, deleteQuery, insertQuery;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              if (!(tableOrName instanceof Table)) {
                _context31.next = 4;
                break;
              }
              _context31.t0 = tableOrName;
              _context31.next = 7;
              break;
            case 4:
              _context31.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context31.t0 = _context31.sent;
            case 7:
              table = _context31.t0;
              column = columnOrName instanceof TableColumn ? columnOrName : table.findColumnByName(columnOrName);
              if (column) {
                _context31.next = 11;
                break;
              }
              throw new TypeORMError("Column \"".concat(columnOrName, "\" was not found in table \"").concat(table.name, "\""));
            case 11:
              clonedTable = table.clone();
              upQueries = [];
              downQueries = []; // drop column index
              columnIndex = clonedTable.indices.find(function (index) {
                return index.columnNames.length === 1 && index.columnNames[0] === column.name;
              });
              if (columnIndex) {
                clonedTable.indices.splice(clonedTable.indices.indexOf(columnIndex), 1);
                upQueries.push(this.dropIndexSql(table, columnIndex));
                downQueries.push(this.createIndexSql(table, columnIndex));
              }
              // drop column check
              columnCheck = clonedTable.checks.find(function (check) {
                return !!check.columnNames && check.columnNames.length === 1 && check.columnNames[0] === column.name;
              });
              if (columnCheck) {
                clonedTable.checks.splice(clonedTable.checks.indexOf(columnCheck), 1);
                upQueries.push(this.dropCheckConstraintSql(table, columnCheck));
                downQueries.push(this.createCheckConstraintSql(table, columnCheck));
              }
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP COLUMN ").concat(this.driver.escape(column.name))));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD ").concat(this.buildCreateColumnSql(column))));
              if (column.generatedType && column.asExpression) {
                deleteQuery = this.deleteTypeormMetadataSql({
                  table: table.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: column.name
                });
                insertQuery = this.insertTypeormMetadataSql({
                  table: table.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: column.name,
                  value: column.asExpression
                });
                upQueries.push(deleteQuery);
                downQueries.push(insertQuery);
              }
              _context31.next = 23;
              return this.executeQueries(upQueries, downQueries);
            case 23:
              clonedTable.removeColumn(column);
              this.replaceCachedTable(table, clonedTable);
            case 25:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function dropColumn(_x44, _x45) {
        return _dropColumn.apply(this, arguments);
      }
      return dropColumn;
    }()
    /**
     * Drops the columns in the table.
     */
  }, {
    key: "dropColumns",
    value: function () {
      var _dropColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(tableOrName, columns) {
        var _iterator5, _step5, column;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _iterator5 = _createForOfIteratorHelper(columns);
              _context32.prev = 1;
              _iterator5.s();
            case 3:
              if ((_step5 = _iterator5.n()).done) {
                _context32.next = 9;
                break;
              }
              column = _step5.value;
              _context32.next = 7;
              return this.dropColumn(tableOrName, column);
            case 7:
              _context32.next = 3;
              break;
            case 9:
              _context32.next = 14;
              break;
            case 11:
              _context32.prev = 11;
              _context32.t0 = _context32["catch"](1);
              _iterator5.e(_context32.t0);
            case 14:
              _context32.prev = 14;
              _iterator5.f();
              return _context32.finish(14);
            case 17:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this, [[1, 11, 14, 17]]);
      }));
      function dropColumns(_x46, _x47) {
        return _dropColumns.apply(this, arguments);
      }
      return dropColumns;
    }()
    /**
     * Creates a new primary key.
     *
     * Not supported in Spanner.
     * @see https://cloud.google.com/spanner/docs/schema-and-data-model#notes_about_key_columns
     */
  }, {
    key: "createPrimaryKey",
    value: function () {
      var _createPrimaryKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(tableOrName, columnNames) {
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              throw new Error("The keys of a table can't change; you can't add a key column to an existing table or remove a key column from an existing table.");
            case 1:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }));
      function createPrimaryKey(_x48, _x49) {
        return _createPrimaryKey.apply(this, arguments);
      }
      return createPrimaryKey;
    }()
    /**
     * Updates composite primary keys.
     */
  }, {
    key: "updatePrimaryKeys",
    value: function () {
      var _updatePrimaryKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(tableOrName, columns) {
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              throw new Error("The keys of a table can't change; you can't add a key column to an existing table or remove a key column from an existing table.");
            case 1:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }));
      function updatePrimaryKeys(_x50, _x51) {
        return _updatePrimaryKeys.apply(this, arguments);
      }
      return updatePrimaryKeys;
    }()
    /**
     * Creates a new primary key.
     *
     * Not supported in Spanner.
     * @see https://cloud.google.com/spanner/docs/schema-and-data-model#notes_about_key_columns
     */
  }, {
    key: "dropPrimaryKey",
    value: function () {
      var _dropPrimaryKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(tableOrName) {
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              throw new Error("The keys of a table can't change; you can't add a key column to an existing table or remove a key column from an existing table.");
            case 1:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }));
      function dropPrimaryKey(_x52) {
        return _dropPrimaryKey.apply(this, arguments);
      }
      return dropPrimaryKey;
    }()
    /**
     * Creates new unique constraint.
     */
  }, {
    key: "createUniqueConstraint",
    value: function () {
      var _createUniqueConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(tableOrName, uniqueConstraint) {
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              throw new TypeORMError("Spanner does not support unique constraints. Use unique index instead.");
            case 1:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }));
      function createUniqueConstraint(_x53, _x54) {
        return _createUniqueConstraint.apply(this, arguments);
      }
      return createUniqueConstraint;
    }()
    /**
     * Creates new unique constraints.
     */
  }, {
    key: "createUniqueConstraints",
    value: function () {
      var _createUniqueConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(tableOrName, uniqueConstraints) {
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              throw new TypeORMError("Spanner does not support unique constraints. Use unique index instead.");
            case 1:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      }));
      function createUniqueConstraints(_x55, _x56) {
        return _createUniqueConstraints.apply(this, arguments);
      }
      return createUniqueConstraints;
    }()
    /**
     * Drops unique constraint.
     */
  }, {
    key: "dropUniqueConstraint",
    value: function () {
      var _dropUniqueConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(tableOrName, uniqueOrName) {
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              throw new TypeORMError("Spanner does not support unique constraints. Use unique index instead.");
            case 1:
            case "end":
              return _context38.stop();
          }
        }, _callee38);
      }));
      function dropUniqueConstraint(_x57, _x58) {
        return _dropUniqueConstraint.apply(this, arguments);
      }
      return dropUniqueConstraint;
    }()
    /**
     * Drops unique constraints.
     */
  }, {
    key: "dropUniqueConstraints",
    value: function () {
      var _dropUniqueConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39(tableOrName, uniqueConstraints) {
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              throw new TypeORMError("Spanner does not support unique constraints. Use unique index instead.");
            case 1:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      }));
      function dropUniqueConstraints(_x59, _x60) {
        return _dropUniqueConstraints.apply(this, arguments);
      }
      return dropUniqueConstraints;
    }()
    /**
     * Creates new check constraint.
     */
  }, {
    key: "createCheckConstraint",
    value: function () {
      var _createCheckConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40(tableOrName, checkConstraint) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              if (!(tableOrName instanceof Table)) {
                _context40.next = 4;
                break;
              }
              _context40.t0 = tableOrName;
              _context40.next = 7;
              break;
            case 4:
              _context40.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context40.t0 = _context40.sent;
            case 7:
              table = _context40.t0;
              // new check constraint may be passed without name. In this case we generate unique name manually.
              if (!checkConstraint.name) checkConstraint.name = this.connection.namingStrategy.checkConstraintName(table, checkConstraint.expression);
              up = this.createCheckConstraintSql(table, checkConstraint);
              down = this.dropCheckConstraintSql(table, checkConstraint);
              _context40.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addCheckConstraint(checkConstraint);
            case 14:
            case "end":
              return _context40.stop();
          }
        }, _callee40, this);
      }));
      function createCheckConstraint(_x61, _x62) {
        return _createCheckConstraint.apply(this, arguments);
      }
      return createCheckConstraint;
    }()
    /**
     * Creates new check constraints.
     */
  }, {
    key: "createCheckConstraints",
    value: function () {
      var _createCheckConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41(tableOrName, checkConstraints) {
        var _this4 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              promises = checkConstraints.map(function (checkConstraint) {
                return _this4.createCheckConstraint(tableOrName, checkConstraint);
              });
              _context41.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      }));
      function createCheckConstraints(_x63, _x64) {
        return _createCheckConstraints.apply(this, arguments);
      }
      return createCheckConstraints;
    }()
    /**
     * Drops check constraint.
     */
  }, {
    key: "dropCheckConstraint",
    value: function () {
      var _dropCheckConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(tableOrName, checkOrName) {
        var table, checkConstraint, up, down;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              if (!(tableOrName instanceof Table)) {
                _context42.next = 4;
                break;
              }
              _context42.t0 = tableOrName;
              _context42.next = 7;
              break;
            case 4:
              _context42.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context42.t0 = _context42.sent;
            case 7:
              table = _context42.t0;
              checkConstraint = checkOrName instanceof TableCheck ? checkOrName : table.checks.find(function (c) {
                return c.name === checkOrName;
              });
              if (checkConstraint) {
                _context42.next = 11;
                break;
              }
              throw new TypeORMError("Supplied check constraint was not found in table ".concat(table.name));
            case 11:
              up = this.dropCheckConstraintSql(table, checkConstraint);
              down = this.createCheckConstraintSql(table, checkConstraint);
              _context42.next = 15;
              return this.executeQueries(up, down);
            case 15:
              table.removeCheckConstraint(checkConstraint);
            case 16:
            case "end":
              return _context42.stop();
          }
        }, _callee42, this);
      }));
      function dropCheckConstraint(_x65, _x66) {
        return _dropCheckConstraint.apply(this, arguments);
      }
      return dropCheckConstraint;
    }()
    /**
     * Drops check constraints.
     */
  }, {
    key: "dropCheckConstraints",
    value: function () {
      var _dropCheckConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43(tableOrName, checkConstraints) {
        var _this5 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              promises = checkConstraints.map(function (checkConstraint) {
                return _this5.dropCheckConstraint(tableOrName, checkConstraint);
              });
              _context43.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context43.stop();
          }
        }, _callee43);
      }));
      function dropCheckConstraints(_x67, _x68) {
        return _dropCheckConstraints.apply(this, arguments);
      }
      return dropCheckConstraints;
    }()
    /**
     * Creates new exclusion constraint.
     */
  }, {
    key: "createExclusionConstraint",
    value: function () {
      var _createExclusionConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44(tableOrName, exclusionConstraint) {
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              throw new TypeORMError("Spanner does not support exclusion constraints.");
            case 1:
            case "end":
              return _context44.stop();
          }
        }, _callee44);
      }));
      function createExclusionConstraint(_x69, _x70) {
        return _createExclusionConstraint.apply(this, arguments);
      }
      return createExclusionConstraint;
    }()
    /**
     * Creates new exclusion constraints.
     */
  }, {
    key: "createExclusionConstraints",
    value: function () {
      var _createExclusionConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45(tableOrName, exclusionConstraints) {
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              throw new TypeORMError("Spanner does not support exclusion constraints.");
            case 1:
            case "end":
              return _context45.stop();
          }
        }, _callee45);
      }));
      function createExclusionConstraints(_x71, _x72) {
        return _createExclusionConstraints.apply(this, arguments);
      }
      return createExclusionConstraints;
    }()
    /**
     * Drops exclusion constraint.
     */
  }, {
    key: "dropExclusionConstraint",
    value: function () {
      var _dropExclusionConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46(tableOrName, exclusionOrName) {
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              throw new TypeORMError("Spanner does not support exclusion constraints.");
            case 1:
            case "end":
              return _context46.stop();
          }
        }, _callee46);
      }));
      function dropExclusionConstraint(_x73, _x74) {
        return _dropExclusionConstraint.apply(this, arguments);
      }
      return dropExclusionConstraint;
    }()
    /**
     * Drops exclusion constraints.
     */
  }, {
    key: "dropExclusionConstraints",
    value: function () {
      var _dropExclusionConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47(tableOrName, exclusionConstraints) {
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              throw new TypeORMError("Spanner does not support exclusion constraints.");
            case 1:
            case "end":
              return _context47.stop();
          }
        }, _callee47);
      }));
      function dropExclusionConstraints(_x75, _x76) {
        return _dropExclusionConstraints.apply(this, arguments);
      }
      return dropExclusionConstraints;
    }()
    /**
     * Creates a new foreign key.
     */
  }, {
    key: "createForeignKey",
    value: function () {
      var _createForeignKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48(tableOrName, foreignKey) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              if (!(tableOrName instanceof Table)) {
                _context48.next = 4;
                break;
              }
              _context48.t0 = tableOrName;
              _context48.next = 7;
              break;
            case 4:
              _context48.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context48.t0 = _context48.sent;
            case 7:
              table = _context48.t0;
              // new FK may be passed without name. In this case we generate FK name manually.
              if (!foreignKey.name) foreignKey.name = this.connection.namingStrategy.foreignKeyName(table, foreignKey.columnNames, this.getTablePath(foreignKey), foreignKey.referencedColumnNames);
              up = this.createForeignKeySql(table, foreignKey);
              down = this.dropForeignKeySql(table, foreignKey);
              _context48.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addForeignKey(foreignKey);
            case 14:
            case "end":
              return _context48.stop();
          }
        }, _callee48, this);
      }));
      function createForeignKey(_x77, _x78) {
        return _createForeignKey.apply(this, arguments);
      }
      return createForeignKey;
    }()
    /**
     * Creates a new foreign keys.
     */
  }, {
    key: "createForeignKeys",
    value: function () {
      var _createForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49(tableOrName, foreignKeys) {
        var _iterator6, _step6, foreignKey;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              _iterator6 = _createForOfIteratorHelper(foreignKeys);
              _context49.prev = 1;
              _iterator6.s();
            case 3:
              if ((_step6 = _iterator6.n()).done) {
                _context49.next = 9;
                break;
              }
              foreignKey = _step6.value;
              _context49.next = 7;
              return this.createForeignKey(tableOrName, foreignKey);
            case 7:
              _context49.next = 3;
              break;
            case 9:
              _context49.next = 14;
              break;
            case 11:
              _context49.prev = 11;
              _context49.t0 = _context49["catch"](1);
              _iterator6.e(_context49.t0);
            case 14:
              _context49.prev = 14;
              _iterator6.f();
              return _context49.finish(14);
            case 17:
            case "end":
              return _context49.stop();
          }
        }, _callee49, this, [[1, 11, 14, 17]]);
      }));
      function createForeignKeys(_x79, _x80) {
        return _createForeignKeys.apply(this, arguments);
      }
      return createForeignKeys;
    }()
    /**
     * Drops a foreign key from the table.
     */
  }, {
    key: "dropForeignKey",
    value: function () {
      var _dropForeignKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50(tableOrName, foreignKeyOrName) {
        var table, foreignKey, up, down;
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!(tableOrName instanceof Table)) {
                _context50.next = 4;
                break;
              }
              _context50.t0 = tableOrName;
              _context50.next = 7;
              break;
            case 4:
              _context50.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context50.t0 = _context50.sent;
            case 7:
              table = _context50.t0;
              foreignKey = foreignKeyOrName instanceof TableForeignKey ? foreignKeyOrName : table.foreignKeys.find(function (fk) {
                return fk.name === foreignKeyOrName;
              });
              if (foreignKey) {
                _context50.next = 11;
                break;
              }
              throw new TypeORMError("Supplied foreign key was not found in table ".concat(table.name));
            case 11:
              up = this.dropForeignKeySql(table, foreignKey);
              down = this.createForeignKeySql(table, foreignKey);
              _context50.next = 15;
              return this.executeQueries(up, down);
            case 15:
              table.removeForeignKey(foreignKey);
            case 16:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this);
      }));
      function dropForeignKey(_x81, _x82) {
        return _dropForeignKey.apply(this, arguments);
      }
      return dropForeignKey;
    }()
    /**
     * Drops a foreign keys from the table.
     */
  }, {
    key: "dropForeignKeys",
    value: function () {
      var _dropForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51(tableOrName, foreignKeys) {
        var _iterator7, _step7, foreignKey;
        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              _iterator7 = _createForOfIteratorHelper(foreignKeys);
              _context51.prev = 1;
              _iterator7.s();
            case 3:
              if ((_step7 = _iterator7.n()).done) {
                _context51.next = 9;
                break;
              }
              foreignKey = _step7.value;
              _context51.next = 7;
              return this.dropForeignKey(tableOrName, foreignKey);
            case 7:
              _context51.next = 3;
              break;
            case 9:
              _context51.next = 14;
              break;
            case 11:
              _context51.prev = 11;
              _context51.t0 = _context51["catch"](1);
              _iterator7.e(_context51.t0);
            case 14:
              _context51.prev = 14;
              _iterator7.f();
              return _context51.finish(14);
            case 17:
            case "end":
              return _context51.stop();
          }
        }, _callee51, this, [[1, 11, 14, 17]]);
      }));
      function dropForeignKeys(_x83, _x84) {
        return _dropForeignKeys.apply(this, arguments);
      }
      return dropForeignKeys;
    }()
    /**
     * Creates a new index.
     */
  }, {
    key: "createIndex",
    value: function () {
      var _createIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52(tableOrName, index) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              if (!(tableOrName instanceof Table)) {
                _context52.next = 4;
                break;
              }
              _context52.t0 = tableOrName;
              _context52.next = 7;
              break;
            case 4:
              _context52.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context52.t0 = _context52.sent;
            case 7:
              table = _context52.t0;
              // new index may be passed without name. In this case we generate index name manually.
              if (!index.name) index.name = this.generateIndexName(table, index);
              up = this.createIndexSql(table, index);
              down = this.dropIndexSql(table, index);
              _context52.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addIndex(index);
            case 14:
            case "end":
              return _context52.stop();
          }
        }, _callee52, this);
      }));
      function createIndex(_x85, _x86) {
        return _createIndex.apply(this, arguments);
      }
      return createIndex;
    }()
    /**
     * Creates a new indices
     */
  }, {
    key: "createIndices",
    value: function () {
      var _createIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53(tableOrName, indices) {
        var _iterator8, _step8, index;
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              _iterator8 = _createForOfIteratorHelper(indices);
              _context53.prev = 1;
              _iterator8.s();
            case 3:
              if ((_step8 = _iterator8.n()).done) {
                _context53.next = 9;
                break;
              }
              index = _step8.value;
              _context53.next = 7;
              return this.createIndex(tableOrName, index);
            case 7:
              _context53.next = 3;
              break;
            case 9:
              _context53.next = 14;
              break;
            case 11:
              _context53.prev = 11;
              _context53.t0 = _context53["catch"](1);
              _iterator8.e(_context53.t0);
            case 14:
              _context53.prev = 14;
              _iterator8.f();
              return _context53.finish(14);
            case 17:
            case "end":
              return _context53.stop();
          }
        }, _callee53, this, [[1, 11, 14, 17]]);
      }));
      function createIndices(_x87, _x88) {
        return _createIndices.apply(this, arguments);
      }
      return createIndices;
    }()
    /**
     * Drops an index from the table.
     */
  }, {
    key: "dropIndex",
    value: function () {
      var _dropIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee54(tableOrName, indexOrName) {
        var table, index, up, down;
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              if (!(tableOrName instanceof Table)) {
                _context54.next = 4;
                break;
              }
              _context54.t0 = tableOrName;
              _context54.next = 7;
              break;
            case 4:
              _context54.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context54.t0 = _context54.sent;
            case 7:
              table = _context54.t0;
              index = indexOrName instanceof TableIndex ? indexOrName : table.indices.find(function (i) {
                return i.name === indexOrName;
              });
              if (index) {
                _context54.next = 11;
                break;
              }
              throw new TypeORMError("Supplied index ".concat(indexOrName, " was not found in table ").concat(table.name));
            case 11:
              // new index may be passed without name. In this case we generate index name manually.
              if (!index.name) index.name = this.generateIndexName(table, index);
              up = this.dropIndexSql(table, index);
              down = this.createIndexSql(table, index);
              _context54.next = 16;
              return this.executeQueries(up, down);
            case 16:
              table.removeIndex(index);
            case 17:
            case "end":
              return _context54.stop();
          }
        }, _callee54, this);
      }));
      function dropIndex(_x89, _x90) {
        return _dropIndex.apply(this, arguments);
      }
      return dropIndex;
    }()
    /**
     * Drops an indices from the table.
     */
  }, {
    key: "dropIndices",
    value: function () {
      var _dropIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee55(tableOrName, indices) {
        var _iterator9, _step9, index;
        return _regeneratorRuntime().wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              _iterator9 = _createForOfIteratorHelper(indices);
              _context55.prev = 1;
              _iterator9.s();
            case 3:
              if ((_step9 = _iterator9.n()).done) {
                _context55.next = 9;
                break;
              }
              index = _step9.value;
              _context55.next = 7;
              return this.dropIndex(tableOrName, index);
            case 7:
              _context55.next = 3;
              break;
            case 9:
              _context55.next = 14;
              break;
            case 11:
              _context55.prev = 11;
              _context55.t0 = _context55["catch"](1);
              _iterator9.e(_context55.t0);
            case 14:
              _context55.prev = 14;
              _iterator9.f();
              return _context55.finish(14);
            case 17:
            case "end":
              return _context55.stop();
          }
        }, _callee55, this, [[1, 11, 14, 17]]);
      }));
      function dropIndices(_x91, _x92) {
        return _dropIndices.apply(this, arguments);
      }
      return dropIndices;
    }()
    /**
     * Clears all table contents.
     * Spanner does not support TRUNCATE TABLE statement, so we use DELETE FROM.
     */
  }, {
    key: "clearTable",
    value: function () {
      var _clearTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee56(tableName) {
        return _regeneratorRuntime().wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              _context56.next = 2;
              return this.query("DELETE FROM ".concat(this.escapePath(tableName), " WHERE true"));
            case 2:
            case "end":
              return _context56.stop();
          }
        }, _callee56, this);
      }));
      function clearTable(_x93) {
        return _clearTable.apply(this, arguments);
      }
      return clearTable;
    }()
    /**
     * Removes all tables from the currently connected database.
     */
  }, {
    key: "clearDatabase",
    value: function () {
      var _clearDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
        var selectIndexDropsQuery, dropIndexQueries, selectFKDropsQuery, dropFKQueries, dropTablesQuery, dropTableQueries, isAnotherTransactionActive, _iterator10, _step10, query, _iterator11, _step11, _query3, _iterator12, _step12, _query4;
        return _regeneratorRuntime().wrap(function _callee57$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              // drop index queries
              selectIndexDropsQuery = "SELECT concat('DROP INDEX `', INDEX_NAME, '`') AS `query` " + "FROM `INFORMATION_SCHEMA`.`INDEXES` " + "WHERE `TABLE_CATALOG` = '' AND `TABLE_SCHEMA` = '' AND `INDEX_TYPE` = 'INDEX' AND `SPANNER_IS_MANAGED` = false";
              _context57.next = 3;
              return this.query(selectIndexDropsQuery);
            case 3:
              dropIndexQueries = _context57.sent;
              // drop foreign key queries
              selectFKDropsQuery = "SELECT concat('ALTER TABLE `', TABLE_NAME, '`', ' DROP CONSTRAINT `', CONSTRAINT_NAME, '`') AS `query` " + "FROM `INFORMATION_SCHEMA`.`TABLE_CONSTRAINTS` " + "WHERE `TABLE_CATALOG` = '' AND `TABLE_SCHEMA` = '' AND `CONSTRAINT_TYPE` = 'FOREIGN KEY'";
              _context57.next = 7;
              return this.query(selectFKDropsQuery);
            case 7:
              dropFKQueries = _context57.sent;
              // drop view queries
              // const selectViewDropsQuery = `SELECT concat('DROP VIEW \`', TABLE_NAME, '\`') AS \`query\` FROM \`INFORMATION_SCHEMA\`.\`VIEWS\``
              // const dropViewQueries: ObjectLiteral[] = await this.query(
              //     selectViewDropsQuery,
              // )
              // drop table queries
              dropTablesQuery = "SELECT concat('DROP TABLE `', TABLE_NAME, '`') AS `query` " + "FROM `INFORMATION_SCHEMA`.`TABLES` " + "WHERE `TABLE_CATALOG` = '' AND `TABLE_SCHEMA` = '' AND `TABLE_TYPE` = 'BASE TABLE'";
              _context57.next = 11;
              return this.query(dropTablesQuery);
            case 11:
              dropTableQueries = _context57.sent;
              if (!(!dropIndexQueries.length && !dropFKQueries.length &&
              // !dropViewQueries.length &&
              !dropTableQueries.length)) {
                _context57.next = 14;
                break;
              }
              return _context57.abrupt("return");
            case 14:
              isAnotherTransactionActive = this.isTransactionActive;
              if (isAnotherTransactionActive) {
                _context57.next = 18;
                break;
              }
              _context57.next = 18;
              return this.startTransaction();
            case 18:
              _context57.prev = 18;
              _iterator10 = _createForOfIteratorHelper(dropIndexQueries);
              _context57.prev = 20;
              _iterator10.s();
            case 22:
              if ((_step10 = _iterator10.n()).done) {
                _context57.next = 28;
                break;
              }
              query = _step10.value;
              _context57.next = 26;
              return this.updateDDL(query["query"]);
            case 26:
              _context57.next = 22;
              break;
            case 28:
              _context57.next = 33;
              break;
            case 30:
              _context57.prev = 30;
              _context57.t0 = _context57["catch"](20);
              _iterator10.e(_context57.t0);
            case 33:
              _context57.prev = 33;
              _iterator10.f();
              return _context57.finish(33);
            case 36:
              _iterator11 = _createForOfIteratorHelper(dropFKQueries);
              _context57.prev = 37;
              _iterator11.s();
            case 39:
              if ((_step11 = _iterator11.n()).done) {
                _context57.next = 45;
                break;
              }
              _query3 = _step11.value;
              _context57.next = 43;
              return this.updateDDL(_query3["query"]);
            case 43:
              _context57.next = 39;
              break;
            case 45:
              _context57.next = 50;
              break;
            case 47:
              _context57.prev = 47;
              _context57.t1 = _context57["catch"](37);
              _iterator11.e(_context57.t1);
            case 50:
              _context57.prev = 50;
              _iterator11.f();
              return _context57.finish(50);
            case 53:
              // for (let query of dropViewQueries) {
              //     await this.updateDDL(query["query"])
              // }
              _iterator12 = _createForOfIteratorHelper(dropTableQueries);
              _context57.prev = 54;
              _iterator12.s();
            case 56:
              if ((_step12 = _iterator12.n()).done) {
                _context57.next = 62;
                break;
              }
              _query4 = _step12.value;
              _context57.next = 60;
              return this.updateDDL(_query4["query"]);
            case 60:
              _context57.next = 56;
              break;
            case 62:
              _context57.next = 67;
              break;
            case 64:
              _context57.prev = 64;
              _context57.t2 = _context57["catch"](54);
              _iterator12.e(_context57.t2);
            case 67:
              _context57.prev = 67;
              _iterator12.f();
              return _context57.finish(67);
            case 70:
              _context57.next = 72;
              return this.commitTransaction();
            case 72:
              _context57.next = 85;
              break;
            case 74:
              _context57.prev = 74;
              _context57.t3 = _context57["catch"](18);
              _context57.prev = 76;
              if (isAnotherTransactionActive) {
                _context57.next = 80;
                break;
              }
              _context57.next = 80;
              return this.rollbackTransaction();
            case 80:
              _context57.next = 84;
              break;
            case 82:
              _context57.prev = 82;
              _context57.t4 = _context57["catch"](76);
            case 84:
              throw _context57.t3;
            case 85:
            case "end":
              return _context57.stop();
          }
        }, _callee57, this, [[18, 74], [20, 30, 33, 36], [37, 47, 50, 53], [54, 64, 67, 70], [76, 82]]);
      }));
      function clearDatabase() {
        return _clearDatabase.apply(this, arguments);
      }
      return clearDatabase;
    }() // -------------------------------------------------------------------------
    // Override Methods
    // -------------------------------------------------------------------------
    /**
     * Executes up sql queries.
     */
  }, {
    key: "executeMemoryUpSql",
    value: function () {
      var _executeMemoryUpSql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
        var _iterator13, _step13, _step13$value, query, parameters;
        return _regeneratorRuntime().wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              _iterator13 = _createForOfIteratorHelper(this.sqlInMemory.upQueries);
              _context58.prev = 1;
              _iterator13.s();
            case 3:
              if ((_step13 = _iterator13.n()).done) {
                _context58.next = 14;
                break;
              }
              _step13$value = _step13.value, query = _step13$value.query, parameters = _step13$value.parameters;
              if (!this.isDMLQuery(query)) {
                _context58.next = 10;
                break;
              }
              _context58.next = 8;
              return this.query(query, parameters);
            case 8:
              _context58.next = 12;
              break;
            case 10:
              _context58.next = 12;
              return this.updateDDL(query, parameters);
            case 12:
              _context58.next = 3;
              break;
            case 14:
              _context58.next = 19;
              break;
            case 16:
              _context58.prev = 16;
              _context58.t0 = _context58["catch"](1);
              _iterator13.e(_context58.t0);
            case 19:
              _context58.prev = 19;
              _iterator13.f();
              return _context58.finish(19);
            case 22:
            case "end":
              return _context58.stop();
          }
        }, _callee58, this, [[1, 16, 19, 22]]);
      }));
      function executeMemoryUpSql() {
        return _executeMemoryUpSql.apply(this, arguments);
      }
      return executeMemoryUpSql;
    }()
    /**
     * Executes down sql queries.
     */
  }, {
    key: "executeMemoryDownSql",
    value: function () {
      var _executeMemoryDownSql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
        var _iterator14, _step14, _step14$value, query, parameters;
        return _regeneratorRuntime().wrap(function _callee59$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              _iterator14 = _createForOfIteratorHelper(this.sqlInMemory.downQueries.reverse());
              _context59.prev = 1;
              _iterator14.s();
            case 3:
              if ((_step14 = _iterator14.n()).done) {
                _context59.next = 14;
                break;
              }
              _step14$value = _step14.value, query = _step14$value.query, parameters = _step14$value.parameters;
              if (!this.isDMLQuery(query)) {
                _context59.next = 10;
                break;
              }
              _context59.next = 8;
              return this.query(query, parameters);
            case 8:
              _context59.next = 12;
              break;
            case 10:
              _context59.next = 12;
              return this.updateDDL(query, parameters);
            case 12:
              _context59.next = 3;
              break;
            case 14:
              _context59.next = 19;
              break;
            case 16:
              _context59.prev = 16;
              _context59.t0 = _context59["catch"](1);
              _iterator14.e(_context59.t0);
            case 19:
              _context59.prev = 19;
              _iterator14.f();
              return _context59.finish(19);
            case 22:
            case "end":
              return _context59.stop();
          }
        }, _callee59, this, [[1, 16, 19, 22]]);
      }));
      function executeMemoryDownSql() {
        return _executeMemoryDownSql.apply(this, arguments);
      }
      return executeMemoryDownSql;
    }() // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
  }, {
    key: "loadViews",
    value: function () {
      var _loadViews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee60(viewNames) {
        return _regeneratorRuntime().wrap(function _callee60$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              return _context60.abrupt("return", Promise.resolve([]));
            case 1:
            case "end":
              return _context60.stop();
          }
        }, _callee60);
      }));
      function loadViews(_x94) {
        return _loadViews.apply(this, arguments);
      }
      return loadViews;
    }()
    /**
     * Loads all tables (with given names) from the database and creates a Table from them.
     */
  }, {
    key: "loadTables",
    value: function () {
      var _loadTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee63(tableNames) {
        var _this6 = this;
        var dbTables, tablesSql, _tablesSql, loadedTableNames, columnsSql, primaryKeySql, indicesSql, checksSql, foreignKeysSql, _yield$Promise$all, _yield$Promise$all2, dbColumns, dbPrimaryKeys, dbIndices, dbChecks, dbForeignKeys;
        return _regeneratorRuntime().wrap(function _callee63$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              if (!(tableNames && tableNames.length === 0)) {
                _context63.next = 2;
                break;
              }
              return _context63.abrupt("return", []);
            case 2:
              dbTables = [];
              if (!(!tableNames || !tableNames.length)) {
                _context63.next = 15;
                break;
              }
              // Since we don't have any of this data we have to do a scan
              tablesSql = "SELECT `TABLE_NAME` " + "FROM `INFORMATION_SCHEMA`.`TABLES` " + "WHERE `TABLE_CATALOG` = '' AND `TABLE_SCHEMA` = '' AND `TABLE_TYPE` = 'BASE TABLE'";
              _context63.t0 = dbTables.push;
              _context63.t1 = dbTables;
              _context63.t2 = _toConsumableArray;
              _context63.next = 10;
              return this.query(tablesSql);
            case 10:
              _context63.t3 = _context63.sent;
              _context63.t4 = (0, _context63.t2)(_context63.t3);
              _context63.t0.apply.call(_context63.t0, _context63.t1, _context63.t4);
              _context63.next = 24;
              break;
            case 15:
              _tablesSql = "SELECT `TABLE_NAME` " + "FROM `INFORMATION_SCHEMA`.`TABLES` " + "WHERE `TABLE_CATALOG` = '' AND `TABLE_SCHEMA` = '' AND `TABLE_TYPE` = 'BASE TABLE' " + "AND `TABLE_NAME` IN (".concat(tableNames.map(function (tableName) {
                return "'".concat(tableName, "'");
              }).join(", "), ")");
              _context63.t5 = dbTables.push;
              _context63.t6 = dbTables;
              _context63.t7 = _toConsumableArray;
              _context63.next = 21;
              return this.query(_tablesSql);
            case 21:
              _context63.t8 = _context63.sent;
              _context63.t9 = (0, _context63.t7)(_context63.t8);
              _context63.t5.apply.call(_context63.t5, _context63.t6, _context63.t9);
            case 24:
              if (dbTables.length) {
                _context63.next = 26;
                break;
              }
              return _context63.abrupt("return", []);
            case 26:
              loadedTableNames = dbTables.map(function (dbTable) {
                return "'".concat(dbTable.TABLE_NAME, "'");
              }).join(", ");
              columnsSql = "SELECT * FROM `INFORMATION_SCHEMA`.`COLUMNS` WHERE `TABLE_CATALOG` = '' AND `TABLE_SCHEMA` = '' AND `TABLE_NAME` IN (".concat(loadedTableNames, ")");
              primaryKeySql = "SELECT `KCU`.`TABLE_NAME`, `KCU`.`COLUMN_NAME` " + "FROM `INFORMATION_SCHEMA`.`TABLE_CONSTRAINTS` `TC` " + "INNER JOIN `INFORMATION_SCHEMA`.`KEY_COLUMN_USAGE` `KCU` ON `KCU`.`CONSTRAINT_NAME` = `TC`.`CONSTRAINT_NAME` " + "WHERE `TC`.`TABLE_CATALOG` = '' AND `TC`.`TABLE_SCHEMA` = '' AND `TC`.`CONSTRAINT_TYPE` = 'PRIMARY KEY' " + "AND `TC`.`TABLE_NAME` IN (".concat(loadedTableNames, ")");
              indicesSql = "SELECT `I`.`TABLE_NAME`, `I`.`INDEX_NAME`, `I`.`IS_UNIQUE`, `I`.`IS_NULL_FILTERED`, `IC`.`COLUMN_NAME` " + "FROM `INFORMATION_SCHEMA`.`INDEXES` `I` " + "INNER JOIN `INFORMATION_SCHEMA`.`INDEX_COLUMNS` `IC` ON `IC`.`INDEX_NAME` = `I`.`INDEX_NAME` " + "AND `IC`.`TABLE_NAME` = `I`.`TABLE_NAME` " + "WHERE `I`.`TABLE_CATALOG` = '' AND `I`.`TABLE_SCHEMA` = '' AND `I`.`TABLE_NAME` IN (".concat(loadedTableNames, ") ") + "AND `I`.`INDEX_TYPE` = 'INDEX' AND `I`.`SPANNER_IS_MANAGED` = false";
              checksSql = "SELECT `TC`.`TABLE_NAME`, `TC`.`CONSTRAINT_NAME`, `CC`.`CHECK_CLAUSE`, `CCU`.`COLUMN_NAME`" + "FROM `INFORMATION_SCHEMA`.`TABLE_CONSTRAINTS` `TC` " + "INNER JOIN `INFORMATION_SCHEMA`.`CONSTRAINT_COLUMN_USAGE` `CCU` ON `CCU`.`CONSTRAINT_NAME` = `TC`.`CONSTRAINT_NAME` " + "INNER JOIN `INFORMATION_SCHEMA`.`CHECK_CONSTRAINTS` `CC` ON `CC`.`CONSTRAINT_NAME` = `TC`.`CONSTRAINT_NAME` " + "WHERE `TC`.`TABLE_CATALOG` = '' AND `TC`.`TABLE_SCHEMA` = '' AND `TC`.`CONSTRAINT_TYPE` = 'CHECK' " + "AND `TC`.`TABLE_NAME` IN (".concat(loadedTableNames, ") AND `TC`.`CONSTRAINT_NAME` NOT LIKE 'CK_IS_NOT_NULL%'");
              foreignKeysSql = "SELECT `TC`.`TABLE_NAME`, `TC`.`CONSTRAINT_NAME`, `KCU`.`COLUMN_NAME`, " + "`CTU`.`TABLE_NAME` AS `REFERENCED_TABLE_NAME`, `CCU`.`COLUMN_NAME` AS `REFERENCED_COLUMN_NAME`, " + "`RC`.`UPDATE_RULE`, `RC`.`DELETE_RULE` " + "FROM `INFORMATION_SCHEMA`.`TABLE_CONSTRAINTS` `TC` " + "INNER JOIN `INFORMATION_SCHEMA`.`KEY_COLUMN_USAGE` `KCU` ON `KCU`.`CONSTRAINT_NAME` = `TC`.`CONSTRAINT_NAME` " + "INNER JOIN `INFORMATION_SCHEMA`.`CONSTRAINT_TABLE_USAGE` `CTU` ON `CTU`.`CONSTRAINT_NAME` = `TC`.`CONSTRAINT_NAME` " + "INNER JOIN `INFORMATION_SCHEMA`.`REFERENTIAL_CONSTRAINTS` `RC` ON `RC`.`CONSTRAINT_NAME` = `TC`.`CONSTRAINT_NAME` " + "INNER JOIN `INFORMATION_SCHEMA`.`CONSTRAINT_COLUMN_USAGE` `CCU` ON `CCU`.`CONSTRAINT_NAME` = `TC`.`CONSTRAINT_NAME` " + "WHERE `TC`.`TABLE_CATALOG` = '' AND `TC`.`TABLE_SCHEMA` = '' AND `TC`.`CONSTRAINT_TYPE` = 'FOREIGN KEY' " + "AND `TC`.`TABLE_NAME` IN (".concat(loadedTableNames, ")");
              _context63.next = 34;
              return Promise.all([this.query(columnsSql), this.query(primaryKeySql), this.query(indicesSql), this.query(checksSql), this.query(foreignKeysSql)]);
            case 34:
              _yield$Promise$all = _context63.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 5);
              dbColumns = _yield$Promise$all2[0];
              dbPrimaryKeys = _yield$Promise$all2[1];
              dbIndices = _yield$Promise$all2[2];
              dbChecks = _yield$Promise$all2[3];
              dbForeignKeys = _yield$Promise$all2[4];
              return _context63.abrupt("return", Promise.all(dbTables.map( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee62(dbTable) {
                  var table, tableForeignKeys, tableIndices, tableChecks;
                  return _regeneratorRuntime().wrap(function _callee62$(_context62) {
                    while (1) switch (_context62.prev = _context62.next) {
                      case 0:
                        table = new Table();
                        table.name = _this6.driver.buildTableName(dbTable["TABLE_NAME"]);
                        // create columns from the loaded columns
                        _context62.next = 4;
                        return Promise.all(dbColumns.filter(function (dbColumn) {
                          return dbColumn["TABLE_NAME"] === dbTable["TABLE_NAME"];
                        }).map( /*#__PURE__*/function () {
                          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee61(dbColumn) {
                            var columnUniqueIndices, tableMetadata, hasIgnoredIndex, isConstraintComposite, tableColumn, fullType, asExpressionQuery, results;
                            return _regeneratorRuntime().wrap(function _callee61$(_context61) {
                              while (1) switch (_context61.prev = _context61.next) {
                                case 0:
                                  columnUniqueIndices = dbIndices.filter(function (dbIndex) {
                                    return dbIndex["TABLE_NAME"] === dbTable["TABLE_NAME"] && dbIndex["COLUMN_NAME"] === dbColumn["COLUMN_NAME"] && dbIndex["IS_UNIQUE"] === true;
                                  });
                                  tableMetadata = _this6.connection.entityMetadatas.find(function (metadata) {
                                    return _this6.getTablePath(table) === _this6.getTablePath(metadata);
                                  });
                                  hasIgnoredIndex = columnUniqueIndices.length > 0 && tableMetadata && tableMetadata.indices.some(function (index) {
                                    return columnUniqueIndices.some(function (uniqueIndex) {
                                      return index.name === uniqueIndex["INDEX_NAME"] && index.synchronize === false;
                                    });
                                  });
                                  isConstraintComposite = columnUniqueIndices.every(function (uniqueIndex) {
                                    return dbIndices.some(function (dbIndex) {
                                      return dbIndex["INDEX_NAME"] === uniqueIndex["INDEX_NAME"] && dbIndex["COLUMN_NAME"] !== dbColumn["COLUMN_NAME"];
                                    });
                                  });
                                  tableColumn = new TableColumn();
                                  tableColumn.name = dbColumn["COLUMN_NAME"];
                                  fullType = dbColumn["SPANNER_TYPE"].toLowerCase();
                                  if (fullType.indexOf("array") !== -1) {
                                    tableColumn.isArray = true;
                                    fullType = fullType.substring(fullType.indexOf("<") + 1, fullType.indexOf(">"));
                                  }
                                  if (fullType.indexOf("(") !== -1) {
                                    tableColumn.type = fullType.substring(0, fullType.indexOf("("));
                                  } else {
                                    tableColumn.type = fullType;
                                  }
                                  if (_this6.driver.withLengthColumnTypes.indexOf(tableColumn.type) !== -1) {
                                    tableColumn.length = fullType.substring(fullType.indexOf("(") + 1, fullType.indexOf(")"));
                                  }
                                  if (!(dbColumn["IS_GENERATED"] === "ALWAYS")) {
                                    _context61.next = 20;
                                    break;
                                  }
                                  tableColumn.asExpression = dbColumn["GENERATION_EXPRESSION"];
                                  tableColumn.generatedType = "STORED";
                                  // We cannot relay on information_schema.columns.generation_expression, because it is formatted different.
                                  _context61.next = 15;
                                  return _this6.selectTypeormMetadataSql({
                                    table: dbTable["TABLE_NAME"],
                                    type: MetadataTableType.GENERATED_COLUMN,
                                    name: tableColumn.name
                                  });
                                case 15:
                                  asExpressionQuery = _context61.sent;
                                  _context61.next = 18;
                                  return _this6.query(asExpressionQuery.query, asExpressionQuery.parameters);
                                case 18:
                                  results = _context61.sent;
                                  if (results[0] && results[0].value) {
                                    tableColumn.asExpression = results[0].value;
                                  } else {
                                    tableColumn.asExpression = "";
                                  }
                                case 20:
                                  tableColumn.isUnique = columnUniqueIndices.length > 0 && !hasIgnoredIndex && !isConstraintComposite;
                                  tableColumn.isNullable = dbColumn["IS_NULLABLE"] === "YES";
                                  tableColumn.isPrimary = dbPrimaryKeys.some(function (dbPrimaryKey) {
                                    return dbPrimaryKey["TABLE_NAME"] === dbColumn["TABLE_NAME"] && dbPrimaryKey["COLUMN_NAME"] === dbColumn["COLUMN_NAME"];
                                  });
                                  return _context61.abrupt("return", tableColumn);
                                case 24:
                                case "end":
                                  return _context61.stop();
                              }
                            }, _callee61);
                          }));
                          return function (_x97) {
                            return _ref2.apply(this, arguments);
                          };
                        }()));
                      case 4:
                        table.columns = _context62.sent;
                        tableForeignKeys = dbForeignKeys.filter(function (dbForeignKey) {
                          return dbForeignKey["TABLE_NAME"] === dbTable["TABLE_NAME"];
                        });
                        table.foreignKeys = OrmUtils.uniq(tableForeignKeys, function (dbForeignKey) {
                          return dbForeignKey["CONSTRAINT_NAME"];
                        }).map(function (dbForeignKey) {
                          var foreignKeys = tableForeignKeys.filter(function (dbFk) {
                            return dbFk["CONSTRAINT_NAME"] === dbForeignKey["CONSTRAINT_NAME"];
                          });
                          return new TableForeignKey({
                            name: dbForeignKey["CONSTRAINT_NAME"],
                            columnNames: OrmUtils.uniq(foreignKeys.map(function (dbFk) {
                              return dbFk["COLUMN_NAME"];
                            })),
                            referencedDatabase: dbForeignKey["REFERENCED_TABLE_SCHEMA"],
                            referencedTableName: dbForeignKey["REFERENCED_TABLE_NAME"],
                            referencedColumnNames: OrmUtils.uniq(foreignKeys.map(function (dbFk) {
                              return dbFk["REFERENCED_COLUMN_NAME"];
                            })),
                            onDelete: dbForeignKey["DELETE_RULE"],
                            onUpdate: dbForeignKey["UPDATE_RULE"]
                          });
                        });
                        tableIndices = dbIndices.filter(function (dbIndex) {
                          return dbIndex["TABLE_NAME"] === dbTable["TABLE_NAME"];
                        });
                        table.indices = OrmUtils.uniq(tableIndices, function (dbIndex) {
                          return dbIndex["INDEX_NAME"];
                        }).map(function (constraint) {
                          var indices = tableIndices.filter(function (index) {
                            return index["INDEX_NAME"] === constraint["INDEX_NAME"];
                          });
                          return new TableIndex({
                            table: table,
                            name: constraint["INDEX_NAME"],
                            columnNames: indices.map(function (i) {
                              return i["COLUMN_NAME"];
                            }),
                            isUnique: constraint["IS_UNIQUE"],
                            isNullFiltered: constraint["IS_NULL_FILTERED"]
                          });
                        });
                        tableChecks = dbChecks.filter(function (dbCheck) {
                          return dbCheck["TABLE_NAME"] === dbTable["TABLE_NAME"];
                        });
                        table.checks = OrmUtils.uniq(tableChecks, function (dbIndex) {
                          return dbIndex["CONSTRAINT_NAME"];
                        }).map(function (constraint) {
                          var checks = tableChecks.filter(function (dbC) {
                            return dbC["CONSTRAINT_NAME"] === constraint["CONSTRAINT_NAME"];
                          });
                          return new TableCheck({
                            name: constraint["CONSTRAINT_NAME"],
                            columnNames: checks.map(function (c) {
                              return c["COLUMN_NAME"];
                            }),
                            expression: constraint["CHECK_CLAUSE"]
                          });
                        });
                        return _context62.abrupt("return", table);
                      case 12:
                      case "end":
                        return _context62.stop();
                    }
                  }, _callee62);
                }));
                return function (_x96) {
                  return _ref.apply(this, arguments);
                };
              }())));
            case 42:
            case "end":
              return _context63.stop();
          }
        }, _callee63, this);
      }));
      function loadTables(_x95) {
        return _loadTables.apply(this, arguments);
      }
      return loadTables;
    }()
    /**
     * Builds create table sql.
     */
  }, {
    key: "createTableSql",
    value: function createTableSql(table, createForeignKeys) {
      var _this7 = this;
      var columnDefinitions = table.columns.map(function (column) {
        return _this7.buildCreateColumnSql(column);
      }).join(", ");
      var sql = "CREATE TABLE ".concat(this.escapePath(table), " (").concat(columnDefinitions);
      // we create unique indexes instead of unique constraints, because Spanner does not have unique constraints.
      // if we mark column as Unique, it means that we create UNIQUE INDEX.
      table.columns.filter(function (column) {
        return column.isUnique;
      }).forEach(function (column) {
        var isUniqueIndexExist = table.indices.some(function (index) {
          return index.columnNames.length === 1 && !!index.isUnique && index.columnNames.indexOf(column.name) !== -1;
        });
        var isUniqueConstraintExist = table.uniques.some(function (unique) {
          return unique.columnNames.length === 1 && unique.columnNames.indexOf(column.name) !== -1;
        });
        if (!isUniqueIndexExist && !isUniqueConstraintExist) table.indices.push(new TableIndex({
          name: _this7.connection.namingStrategy.uniqueConstraintName(table, [column.name]),
          columnNames: [column.name],
          isUnique: true
        }));
      });
      // as Spanner does not have unique constraints, we must create table indices from table uniques and mark them as unique.
      if (table.uniques.length > 0) {
        table.uniques.forEach(function (unique) {
          var uniqueExist = table.indices.some(function (index) {
            return index.name === unique.name;
          });
          if (!uniqueExist) {
            table.indices.push(new TableIndex({
              name: unique.name,
              columnNames: unique.columnNames,
              isUnique: true
            }));
          }
        });
      }
      if (table.checks.length > 0) {
        var checksSql = table.checks.map(function (check) {
          var checkName = check.name ? check.name : _this7.connection.namingStrategy.checkConstraintName(table, check.expression);
          return "CONSTRAINT `".concat(checkName, "` CHECK (").concat(check.expression, ")");
        }).join(", ");
        sql += ", ".concat(checksSql);
      }
      if (table.foreignKeys.length > 0 && createForeignKeys) {
        var foreignKeysSql = table.foreignKeys.map(function (fk) {
          var columnNames = fk.columnNames.map(function (columnName) {
            return "`".concat(columnName, "`");
          }).join(", ");
          if (!fk.name) fk.name = _this7.connection.namingStrategy.foreignKeyName(table, fk.columnNames, _this7.getTablePath(fk), fk.referencedColumnNames);
          var referencedColumnNames = fk.referencedColumnNames.map(function (columnName) {
            return "`".concat(columnName, "`");
          }).join(", ");
          return "CONSTRAINT `".concat(fk.name, "` FOREIGN KEY (").concat(columnNames, ") REFERENCES ").concat(_this7.escapePath(_this7.getTablePath(fk)), " (").concat(referencedColumnNames, ")");
        }).join(", ");
        sql += ", ".concat(foreignKeysSql);
      }
      sql += ")";
      var primaryColumns = table.columns.filter(function (column) {
        return column.isPrimary;
      });
      if (primaryColumns.length > 0) {
        var columnNames = primaryColumns.map(function (column) {
          return _this7.driver.escape(column.name);
        }).join(", ");
        sql += " PRIMARY KEY (".concat(columnNames, ")");
      }
      return new Query(sql);
    }
    /**
     * Builds drop table sql.
     */
  }, {
    key: "dropTableSql",
    value: function dropTableSql(tableOrPath) {
      return new Query("DROP TABLE ".concat(this.escapePath(tableOrPath)));
    }
  }, {
    key: "createViewSql",
    value: function createViewSql(view) {
      var materializedClause = view.materialized ? "MATERIALIZED " : "";
      var viewName = this.escapePath(view);
      var expression = typeof view.expression === "string" ? view.expression : view.expression(this.connection).getQuery();
      return new Query("CREATE ".concat(materializedClause, "VIEW ").concat(viewName, " SQL SECURITY INVOKER AS ").concat(expression));
    }
  }, {
    key: "insertViewDefinitionSql",
    value: function () {
      var _insertViewDefinitionSql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee64(view) {
        var _this$driver$parseTab, schema, name, type, expression;
        return _regeneratorRuntime().wrap(function _callee64$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              _this$driver$parseTab = this.driver.parseTableName(view), schema = _this$driver$parseTab.schema, name = _this$driver$parseTab.tableName;
              type = view.materialized ? MetadataTableType.MATERIALIZED_VIEW : MetadataTableType.VIEW;
              expression = typeof view.expression === "string" ? view.expression.trim() : view.expression(this.connection).getQuery();
              return _context64.abrupt("return", this.insertTypeormMetadataSql({
                type: type,
                schema: schema,
                name: name,
                value: expression
              }));
            case 4:
            case "end":
              return _context64.stop();
          }
        }, _callee64, this);
      }));
      function insertViewDefinitionSql(_x98) {
        return _insertViewDefinitionSql.apply(this, arguments);
      }
      return insertViewDefinitionSql;
    }()
    /**
     * Builds drop view sql.
     */
  }, {
    key: "dropViewSql",
    value: function dropViewSql(view) {
      var materializedClause = view.materialized ? "MATERIALIZED " : "";
      return new Query("DROP ".concat(materializedClause, "VIEW ").concat(this.escapePath(view)));
    }
    /**
     * Builds remove view sql.
     */
  }, {
    key: "deleteViewDefinitionSql",
    value: function () {
      var _deleteViewDefinitionSql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee65(view) {
        var _this$driver$parseTab2, schema, name, type;
        return _regeneratorRuntime().wrap(function _callee65$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              _this$driver$parseTab2 = this.driver.parseTableName(view), schema = _this$driver$parseTab2.schema, name = _this$driver$parseTab2.tableName;
              type = view.materialized ? MetadataTableType.MATERIALIZED_VIEW : MetadataTableType.VIEW;
              return _context65.abrupt("return", this.deleteTypeormMetadataSql({
                type: type,
                schema: schema,
                name: name
              }));
            case 3:
            case "end":
              return _context65.stop();
          }
        }, _callee65, this);
      }));
      function deleteViewDefinitionSql(_x99) {
        return _deleteViewDefinitionSql.apply(this, arguments);
      }
      return deleteViewDefinitionSql;
    }()
    /**
     * Builds create index sql.
     */
  }, {
    key: "createIndexSql",
    value: function createIndexSql(table, index) {
      var _this8 = this;
      var columns = index.columnNames.map(function (columnName) {
        return _this8.driver.escape(columnName);
      }).join(", ");
      var indexType = "";
      if (index.isUnique) indexType += "UNIQUE ";
      if (index.isNullFiltered) indexType += "NULL_FILTERED ";
      return new Query("CREATE ".concat(indexType, "INDEX `").concat(index.name, "` ON ").concat(this.escapePath(table), " (").concat(columns, ")"));
    }
    /**
     * Builds drop index sql.
     */
  }, {
    key: "dropIndexSql",
    value: function dropIndexSql(table, indexOrName) {
      var indexName = indexOrName instanceof TableIndex ? indexOrName.name : indexOrName;
      return new Query("DROP INDEX `".concat(indexName, "`"));
    }
    /**
     * Builds create check constraint sql.
     */
  }, {
    key: "createCheckConstraintSql",
    value: function createCheckConstraintSql(table, checkConstraint) {
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT `").concat(checkConstraint.name, "` CHECK (").concat(checkConstraint.expression, ")"));
    }
    /**
     * Builds drop check constraint sql.
     */
  }, {
    key: "dropCheckConstraintSql",
    value: function dropCheckConstraintSql(table, checkOrName) {
      var checkName = checkOrName instanceof TableCheck ? checkOrName.name : checkOrName;
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT `").concat(checkName, "`"));
    }
    /**
     * Builds create foreign key sql.
     */
  }, {
    key: "createForeignKeySql",
    value: function createForeignKeySql(table, foreignKey) {
      var _this9 = this;
      var columnNames = foreignKey.columnNames.map(function (column) {
        return _this9.driver.escape(column);
      }).join(", ");
      var referencedColumnNames = foreignKey.referencedColumnNames.map(function (column) {
        return _this9.driver.escape(column);
      }).join(",");
      var sql = "ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT `").concat(foreignKey.name, "` FOREIGN KEY (").concat(columnNames, ") ") + "REFERENCES ".concat(this.escapePath(this.getTablePath(foreignKey)), " (").concat(referencedColumnNames, ")");
      return new Query(sql);
    }
    /**
     * Builds drop foreign key sql.
     */
  }, {
    key: "dropForeignKeySql",
    value: function dropForeignKeySql(table, foreignKeyOrName) {
      var foreignKeyName = foreignKeyOrName instanceof TableForeignKey ? foreignKeyOrName.name : foreignKeyOrName;
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT `").concat(foreignKeyName, "`"));
    }
    /**
     * Escapes given table or view path.
     */
  }, {
    key: "escapePath",
    value: function escapePath(target) {
      var _this$driver$parseTab3 = this.driver.parseTableName(target),
        tableName = _this$driver$parseTab3.tableName;
      return "`".concat(tableName, "`");
    }
    /**
     * Builds a part of query to create/change a column.
     */
  }, {
    key: "buildCreateColumnSql",
    value: function buildCreateColumnSql(column) {
      var c = "".concat(this.driver.escape(column.name), " ").concat(this.connection.driver.createFullType(column));
      // Spanner supports only STORED generated column type
      if (column.generatedType === "STORED" && column.asExpression) {
        c += " AS (".concat(column.asExpression, ") STORED");
      } else {
        if (!column.isNullable) c += " NOT NULL";
      }
      return c;
    }
    /**
     * Executes sql used special for schema build.
     */
  }, {
    key: "executeQueries",
    value: function () {
      var _executeQueries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee66(upQueries, downQueries) {
        var _this$sqlInMemory$upQ, _this$sqlInMemory$dow;
        var _iterator15, _step15, _step15$value, query, parameters;
        return _regeneratorRuntime().wrap(function _callee66$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              if (upQueries instanceof Query) upQueries = [upQueries];
              if (downQueries instanceof Query) downQueries = [downQueries];
              (_this$sqlInMemory$upQ = this.sqlInMemory.upQueries).push.apply(_this$sqlInMemory$upQ, _toConsumableArray(upQueries));
              (_this$sqlInMemory$dow = this.sqlInMemory.downQueries).push.apply(_this$sqlInMemory$dow, _toConsumableArray(downQueries));
              // if sql-in-memory mode is enabled then simply store sql in memory and return
              if (!(this.sqlMemoryMode === true)) {
                _context66.next = 6;
                break;
              }
              return _context66.abrupt("return", Promise.resolve());
            case 6:
              _iterator15 = _createForOfIteratorHelper(upQueries);
              _context66.prev = 7;
              _iterator15.s();
            case 9:
              if ((_step15 = _iterator15.n()).done) {
                _context66.next = 20;
                break;
              }
              _step15$value = _step15.value, query = _step15$value.query, parameters = _step15$value.parameters;
              if (!this.isDMLQuery(query)) {
                _context66.next = 16;
                break;
              }
              _context66.next = 14;
              return this.query(query, parameters);
            case 14:
              _context66.next = 18;
              break;
            case 16:
              _context66.next = 18;
              return this.updateDDL(query, parameters);
            case 18:
              _context66.next = 9;
              break;
            case 20:
              _context66.next = 25;
              break;
            case 22:
              _context66.prev = 22;
              _context66.t0 = _context66["catch"](7);
              _iterator15.e(_context66.t0);
            case 25:
              _context66.prev = 25;
              _iterator15.f();
              return _context66.finish(25);
            case 28:
            case "end":
              return _context66.stop();
          }
        }, _callee66, this, [[7, 22, 25, 28]]);
      }));
      function executeQueries(_x100, _x101) {
        return _executeQueries.apply(this, arguments);
      }
      return executeQueries;
    }()
  }, {
    key: "isDMLQuery",
    value: function isDMLQuery(query) {
      return query.startsWith("INSERT") || query.startsWith("UPDATE") || query.startsWith("DELETE");
    }
  }]);
  return SpannerQueryRunner;
}(BaseQueryRunner);